export const asyncMessagesLoader = language => import(/* webpackChunkName: "[request]" */`../assets/locale/common-errors/common-errors_${language}.json`);
//# sourceMappingURL=asyncMessagesLoader.js.map